export default __webpack_public_path__ + "static/media/wh_5.3efeda19.mp3";